import { render, staticRenderFns } from "./a-sticky-nav.vue?vue&type=template&id=49a64900&"
import script from "./a-sticky-nav.vue?vue&type=script&lang=js&"
export * from "./a-sticky-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports